__turbopack_context__.v({
  "boxFilePreviewWrapper": "nklGKq_boxFilePreviewWrapper",
  "filePreviewWrapper": "nklGKq_filePreviewWrapper",
  "fileWidgetInput": "nklGKq_fileWidgetInput",
  "imagePreviewInfoLabel": "nklGKq_imagePreviewInfoLabel",
  "imagePreviewWrapper": "nklGKq_imagePreviewWrapper",
  "multiple": "nklGKq_multiple",
  "preview": "nklGKq_preview",
  "previewIcon": "nklGKq_previewIcon",
  "previewInfo": "nklGKq_previewInfo",
  "removeFileButton": "nklGKq_removeFileButton",
  "wrapper": "nklGKq_wrapper",
});
